<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"
            ><i class="icon-close"></i
          ></a>
          <h3 class="modal-title">輸入客戶身分證字號</h3>
        </div>
        <div class="modal-body" style="min-height: 240px">
          <section class="search">
            <div class="row">
              <content>
                <slot name="content"></slot>
              </content>
            </div>
            <div class="row mb-3">
              <form class="form">
                <div class="form-group row">
                  <div class="offset-2 text-right text-bold font-20 pr-2 pt-2">
                    身分證
                  </div>
                  <div class="col-7">
                    <input
                      type="text"
                      maxlength="10"
                      name="keyword"
                      id="keyowrd"
                      class="form-control"
                      v-model="editData.csidno"
                      placeholder="身分證字號"
                      @input="checkKeyword"
                      @blur="checkKeyword"
                    />
                    <span
                      id="searchclear"
                      v-show="editData.csidno"
                      @click="cleanSearch()"
                      >清除</span
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <div class="offset-2 text-right text-bold font-20 pr-3 pt-2">
                    &emsp;性別
                  </div>
                  <div class="radio radio-inline">
                    <input
                      type="radio"
                      value="1"
                      v-model="editData.sex"
                      id="male"
                      data-vv-as="性別"
                    />
                    <label for="male">男</label>
                  </div>
                  <div class="radio radio-inline">
                    <input
                      type="radio"
                      value="2"
                      id="female"
                      v-model="editData.sex"
                      data-vv-as="性別"
                    />
                    <label for="female">女</label>
                  </div>
                </div>
              </form>
            </div>
          </section>
          <section class="action text-right mr-3">
            <a class="btn btn-default" @click="$emit('close')"> 取消 </a>
            <a class="btn btn-primary" @click="doSubmit()"> 確認 </a>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { idCheck } from "@/service/modules/validation";
export default {
  name: "addIdModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    target: Object
  },
  data() {
    return {
      editData: {}
    };
  },
  watch: {
    open: "cleanSearch",
    "editData.csidno": "syncSex",
    target: {
      immediate: true,
      handler() {
        this.editData = this.target;
      }
    }
  },
  methods: {
    //輸入身分證後選擇性別
    syncSex(id) {
      if (id.length > 1) {
        var sexOfId = id.substr(1, 1).toUpperCase();
        if (sexOfId.match("1|8|A|C")) {
          this.editData.sex = "1";
        } else if (sexOfId.match("2|9|B|D")) {
          this.editData.sex = "2";
        }
      }
    },
    doSubmit() {
      if (this.checkValidate()) {
        this.$emit("confirm", this.editData);
      }
    },
    //ID驗證
    checkValidate() {
      if (!this.editData.csidno) {
        this.$toast.info({ title: "不可為空" });
        return false;
      }
      let val = this.editData.csidno.substring(0, 1);
      if (val === "*" && this.editData.csidno.length != 10) {
        this.$toast.info({ title: "此ID長度不符" });
        return false;
      }
      if (val != "*" && !idCheck(this.editData.csidno)) {
        this.$toast.info({ title: "此ID格式有誤" });
        return false;
      }
      return true;
    },
    //限制輸入欄位
    checkKeyword() {
      if (this.editData.csidno) {
        this.editData.csidno = this.editData.csidno.toUpperCase();
        let val = this.editData.csidno.substring(0, 1);
        if (val === "*") {
          this.editData.csidno =
            val +
            this.editData.csidno
              .substring(1, this.editData.csidno.length)
              .replace(/[^a-zA-Z0-9]+/g, "");
        } else {
          this.editData.csidno = this.editData.csidno.replace(
            /[^a-zA-Z0-9]+/g,
            ""
          );
        }
      }
      if (this.stringBytes(this.editData.csidno, false, 10) > 10) {
        this.editData.csidno = this.editData.csidno.substring(
          0,
          this.stringBytes(this.editData.csidno, true, 10)
        );
      }
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      var n = c.length,
        s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    cleanSearch() {
      this.editData.csidno = "";
    }
  }
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 20px;
  top: 10px;
  bottom: 0;
  margin-right: 25px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
</style>
